import { encryptData } from "../dashboard-service/encryptionService";

export const login = async (email, password) => {
    let statusCode;
    let apiResponse;
    localStorage.removeItem("chat_id")
    localStorage.removeItem("currentChats")
    localStorage.removeItem("selectedParts");
    const raw = JSON.stringify({
        email: email,
        password: btoa(password)
    })
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: raw,
        redirect: 'follow'
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}Authenticate`, requestOptions).then(async response => {
        statusCode = response.status;
        apiResponse = await response.json();
    }).catch(error => {
        return error;
    })
    if (apiResponse && apiResponse.status && apiResponse.status === 200) {
        localStorage.setItem("userData", encryptData(JSON.stringify(apiResponse.User)))
        return apiResponse;
    }
    else {
        return apiResponse;
    }
}

